/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from 'react'
import Helmet from 'react-helmet'
import { useStaticQuery, graphql } from 'gatsby'
import { useSelector } from '~/store/hooks'

// import FontCss from "../../static/fonts/fonts.css"

function Seo({
  frUrl,
  enUrl,
  page,
  noIndex = false,
  newsroomPage = 0,
  newsroomProfile = false,
  newsroomFrProfile = false,
  newsroomEnProfile = false,
}) {
  const lang = useSelector((state) => state.lang)

  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          title
          description
          descriptionEN
          baseUrl
          image
        }
      }
    }
  `)

  const defaults = data.site.siteMetadata
  const defaultsDescription =
    lang === 'fr' ? defaults.description : defaults.descriptionEN
  const defaultsUrl = lang === 'fr' ? defaults.baseUrl : `${defaults.baseUrl}en`

  const title = page.title ? page.title : defaults.title
  const description = page.description ? page.description : defaultsDescription
  const url = page.path
    ? `${defaults.baseUrl.slice(0, -1)}${page.path}`
    : defaultsUrl
  let image = page.image ? page.image : defaults.image
  image = image.replace(
    '//images.ctfassets.net',
    'https://images.ctfassets.net',
  )

  const twitterImage = `${image}?fit=fill&f=center&w=800&h=400`

  return (
    <Helmet encodeSpecialCharacters={false}>
      <title>{title}</title>
      <link
        rel="canonical"
        href={`${url}${newsroomPage > 1 ? `/page/${newsroomPage}` : ''}`}
      />
      <meta name="description" content={description} />
      {image && <meta name="image" content={image} />}

      {noIndex && <meta name="robots" content="noindex"></meta>}

      <meta
        name="google-site-verification"
        content="JgScpX9e-FuzEqOT4z4hFqm4bv0Be2oDCdjfCBpzczc"
      />

      {enUrl && (
        <link
          rel="alternate"
          hreflang="fr"
          href={`${defaults.baseUrl.slice(0, -1)}${frUrl}${newsroomPage > 1 ? `/page/${newsroomPage}` : ''}`}
        />
      )}
      {enUrl && (
        <link
          rel="alternate"
          hreflang="en"
          href={`${defaults.baseUrl.slice(0, -1)}${enUrl}${newsroomPage > 1 ? `/page/${newsroomPage}` : ''}`}
        />
      )}

      <meta property="og:url" content={url} />
      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      {image && <meta property="og:image" content={image} />}

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:creator" content="@Teregacontact" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      {image && <meta name="twitter:image" content={twitterImage} />}

      <script type="application/ld+json">
        {`{
          "@context": "https://schema.org",
          "@type": "WebSite",
          "url": "${defaults.baseUrl}",
          "potentialAction": {
            "@type": "SearchAction",
            "target": "${defaults.baseUrl.slice(0, -1)}/${lang === 'fr' ? 'recherche' : 'search'}?q={search_term_string}",
            "query-input": "required name=search_term_string"
          }
        }`}
      </script>
        <script type="application/ld+json">
        {`{
            "@context": "https://schema.org",
            "@type": "Organization",
            "url": "${defaults.baseUrl}",
            "logo": "${defaults.baseUrl}img/logo.svg",
            "name": "Teréga",
            "description": "Teréga est un acteur majeur des infrastructures de transport et de stockage de gaz en France et en Europe. Engagé dans la transition énergétique, Teréga développe des solutions innovantes pour décarboner les usages énergétiques.",
            "address": {
                "@type": "PostalAddress",
                "streetAddress": "40 avenue de l'Europe, CS 20522",
                "addressLocality": "PAU Cedex",
                "postalCode": "64010",
                "addressCountry": "France"
            },
            "contactPoint": {
                "@type": "ContactPoint",
                "telephone": "+33 559 133 400",
                "contactType": "Service client"
            },
            "sameAs": [
                "https://www.linkedin.com/company/terega/",
                "https://twitter.com/terega_fr"
            ]
        }`}
        </script>
    </Helmet>
  )
}

export default Seo
